import React, { useEffect, useState } from 'react';
import { BookOpen, Check, X, Clock, ShieldCheck, Star, ChevronDown, Sparkles, Map, Mic, PenTool } from 'lucide-react';

// ---------------------------------------------------------------------------
// Data (copy ported from the live landing at escribir-un-libro-con-ia.impultienda.ar)
// ---------------------------------------------------------------------------

const MAIN_IMG = 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/render/image/public/ebook-images/ff7fd6ed-7267-4177-916c-09cd62023ba2/5ebdf9b5-8f12-4614-bfb4-fd1f8f1fa66c-mockup.jpg?width=1000&quality=90&resize=contain';
const BONUSES = [{
  n: '01',
  title: 'Claude Code desde cero',
  solves: 'Para cuando sientas que la parte técnica te frena',
  desc: 'Aprende a crear páginas web, herramientas y automatizaciones con Claude Code, sin experiencia previa en programación. Incluye 41 lecciones prácticas en español, con ejercicios y prompts para avanzar paso a paso.',
  value: 'MX$ 397',
  img: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/render/image/public/ebook-images/ff7fd6ed-7267-4177-916c-09cd62023ba2/0a5efea2-6bc5-4dea-af83-83d126a295da-mockup.png?width=500&quality=85&resize=contain'
}, {
  n: '02',
  title: 'Publica tu libro en Amazon KDP',
  solves: 'Para cuando termines tu borrador y no sepas qué sigue',
  desc: 'Aprende a preparar tu manuscrito y configurar su publicación en Amazon como ebook o libro impreso. Incluye orientación sobre el uso de IA, ejercicios, 5 prompts y un checklist para revisar todo antes de publicar.',
  value: 'MX$ 297',
  img: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/render/image/public/ebook-images/ff7fd6ed-7267-4177-916c-09cd62023ba2/f57ce43c-f923-4388-85d4-c5fe3085f2ef-mockup.png?width=500&quality=85&resize=contain'
}, {
  n: '03',
  title: 'Caja de herramientas: 41 prompts para trabajar con IA',
  solves: 'Para cuando no sepas qué pedirle exactamente a la IA',
  desc: '41 prompts listos para adaptar a tus tareas: escribir textos, crear imágenes, preparar propuestas y organizar ideas. Incluye ejemplos y una guía para elegir herramientas y guardar tus mejores prompts, con Claude y otras IA.',
  value: 'MX$ 197',
  img: 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/render/image/public/ebook-images/ff7fd6ed-7267-4177-916c-09cd62023ba2/0e340ce0-a388-439d-bd6e-d409fb59df7c-mockup.png?width=500&quality=85&resize=contain'
}];
const PAIN_POINTS = [{
  title: 'Tienes recuerdos, pero no sabes por dónde empezar',
  desc: 'Imágenes, frases y escenas sueltas se te acumulan, pero no aterrizan en una historia con dirección.'
}, {
  title: 'Te falta orden y se te rompe el hilo',
  desc: 'Sin una estructura clara, avanzas por partes y luego te cuesta conectar escenas o sostener la continuidad.'
}, {
  title: 'La IA te devuelve texto genérico',
  desc: 'Recibes borradores que suenan correctos, pero no representan tu intención, tus decisiones ni lo que de verdad quieres contar.'
}, {
  title: 'Te atoras con la revisión y la corrección',
  desc: 'Identificar qué cambiar, qué conservar y cómo mejorar sin perder tu estilo se vuelve más pesado que escribir.'
}];
const FEATURES = [{
  icon: BookOpen,
  title: 'Sales de la página en blanco',
  desc: 'Aprendes un punto de arranque concreto para escribir tu primer párrafo y seguir sin perderte en ideas sueltas.'
}, {
  icon: Map,
  title: 'Estructura que sostiene la historia',
  desc: 'Pasas de inspiración a premisa, personajes, mundo narrativo y un mapa claro para organizar la trama.'
}, {
  icon: PenTool,
  title: 'Escenas que avanzan con intención',
  desc: 'Te guía para escribir y revisar escenas con conflicto, intención y desarrollo, sin quedarte en descripciones genéricas.'
}, {
  icon: Mic,
  title: 'Tu voz, no la de la IA',
  desc: 'Detectas repeticiones y tics del texto generado para ajustar el estilo y que la historia se sienta tuya.'
}];
const STEPS = [{
  n: '1',
  title: 'Hoy: escribes tu primer párrafo',
  desc: 'Aprendes a romper la página en blanco con una base clara para abrir tu historia y generar el primer texto útil, en tu primera sesión.'
}, {
  n: '2',
  title: 'Estructuras y construyes tu biblia',
  desc: 'Definimos premisa, personajes, mundo narrativo y continuidad para que tu escritura no se te rompa en el camino.'
}, {
  n: '3',
  title: 'Escribes escena por escena y revisas con método',
  desc: 'Usas un proceso repetible: pides propuestas a la IA, evalúas, pides cambios concretos y avanzas hacia un primer borrador compartible.'
}];
const FAQS = [{
  q: '¿Necesito saber usar inteligencia artificial antes de empezar?',
  a: 'No. El método te enseña cómo dar instrucciones, cómo pedir cambios y cómo evaluar lo que genera la IA. Tú aportas tu intención y tus detalles; la IA te acompaña para organizar y redactar.'
}, {
  q: '¿Y si solo tengo recuerdos sueltos, sin trama?',
  a: 'Este ebook está pensado para eso. Aprenderás a convertir escenas sueltas en una premisa clara, a definir personajes y a estructurar la trama para que puedas avanzar paso a paso.'
}, {
  q: '¿La IA escribirá con mi "voz" automáticamente?',
  a: 'No automáticamente, y justo por eso el método incluye revisión, detección de repeticiones y ajustes para que el texto final conserve tu estilo, tus decisiones y la intención con la que quieres contar la historia.'
}, {
  q: '¿Puedo usar personas o eventos reales de mi familia?',
  a: 'Sí, pero tú debes aportar los datos y revisarlos. Cuando uses algo real, trátalo con cuidado: lo inventado debe tratarse como ficción. El enfoque principal es escribir narrativa de ficción, inspirada en tu memoria.'
}];
const PRICE_ORIGINAL = 697; // valor de referencia del ebook solo
const PRICE_OFFER = 247; // precio final de venta — tope fijado en ~15 USD
const BONUS_TOTAL = 397 + 297 + 197;
const BUNDLE_VALUE = PRICE_ORIGINAL + BONUS_TOTAL; // MX$ 1.588 — valor del ebook + los 3 bonos
const SAVINGS = BUNDLE_VALUE - PRICE_OFFER;
function formatMXN(n: number) {
  return 'MX$ ' + n.toLocaleString('es-MX');
}

// ---------------------------------------------------------------------------
// Small building blocks
// ---------------------------------------------------------------------------

function useCountdown(initialSeconds: number) {
  const [seconds, setSeconds] = useState(initialSeconds);
  useEffect(() => {
    const id = setInterval(() => {
      setSeconds(s => s <= 1 ? initialSeconds : s - 1);
    }, 1000);
    return () => clearInterval(id);
  }, [initialSeconds]);
  const mm = String(Math.floor(seconds / 60)).padStart(2, '0');
  const ss = String(seconds % 60).padStart(2, '0');
  return `${mm}:${ss}`;
}
function Eyebrow({
  children,
  light = false
}: {
  children: React.ReactNode;
  light?: boolean;
}) {
  return <p className={`text-xs font-bold uppercase tracking-[0.18em] mb-4 ${light ? 'text-gold' : 'text-brand'}`} data-id="element-0" data-mp="3i3wezrvkg22g">
      {children}
    </p>;
}
function PrimaryButton({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <a href="#oferta" className={`inline-flex items-center justify-center gap-3 bg-brand text-white font-bold uppercase text-sm tracking-wider px-8 py-5 rounded shadow-[0_10px_30px_rgba(237,91,25,0.25)] transition-transform hover:-translate-y-0.5 hover:shadow-[0_16px_35px_rgba(237,91,25,0.32)] ${className}`} data-id="element-1" data-mp="3d4a25jjngnu6">
      {children}
    </a>;
}
function SectionHead({
  eyebrow,
  title,
  desc,
  light = false,
  center = false
}: {
  eyebrow: string;
  title: React.ReactNode;
  desc?: string;
  light?: boolean;
  center?: boolean;
}) {
  return <div className={`max-w-2xl mb-16 ${center ? 'mx-auto text-center' : ''}`} data-id="element-2" data-mp="2ggdoonjie8n6">
      <Eyebrow light={light} data-id="element-3" data-mp="2kfcppx24dl9c">{eyebrow}</Eyebrow>
      <h2 className={`font-serif tracking-tight leading-[1.05] text-[clamp(32px,5vw,52px)] mb-4 ${light ? 'text-white' : 'text-ink'}`} data-id="element-4" data-mp="30v3vmqe1h010">
        {title}
      </h2>
      {desc && <p className={`text-lg leading-relaxed ${light ? 'text-[#b8cfca]' : 'text-muted'}`} data-id="element-5" data-mp="2qwekdggnedtq">
          {desc}
        </p>}
    </div>;
}

// ---------------------------------------------------------------------------
// App
// ---------------------------------------------------------------------------

export function App() {
  const timer = useCountdown(15 * 60);
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  return <div className="w-full min-h-full bg-paper text-ink font-sans antialiased" data-id="element-6" data-mp="284ltbrl532on">
      {/* Urgency bar — full width, sticky, always visible */}
      <div className="sticky top-0 z-30 bg-ink text-white border-b border-brand/40" data-id="element-7" data-mp="1y920je1vgk44">
        <div className="w-full px-4 py-3 flex items-center justify-center gap-3 sm:gap-4 text-center" data-id="element-8" data-mp="1u770ecvogcrx">
          <span className="text-xs sm:text-sm font-bold uppercase tracking-[0.1em] whitespace-nowrap" data-id="element-9" data-mp="9pfmp1inbind">
            🔥 Oferta termina en
          </span>
          <span className="font-serif text-2xl sm:text-3xl font-bold tabular-nums text-brand bg-white/10 px-4 py-1 rounded tracking-wider" data-id="element-10" data-mp="dooh88lifkjz">
            {timer}
          </span>
          <span className="hidden md:inline text-xs uppercase tracking-[0.1em] text-[#b8cfca] whitespace-nowrap" data-id="element-11" data-mp="nncme6sec569">
            · Quedan pocos cupos a este precio
          </span>
        </div>
      </div>

      {/* Hero */}
      <section className="relative overflow-hidden border-b border-ink/10" data-id="element-12" data-mp="3r5npoj1ogf9i">
        <div className="max-w-6xl mx-auto px-5 grid lg:grid-cols-[1.05fr_0.95fr] gap-12 items-center py-16 lg:py-24" data-id="element-13" data-mp="3w3pab8er4mn3">
          <div data-id="element-14" data-mp="4r4e0u437e6q">
            <Eyebrow data-id="element-15" data-mp="4rmige0wkypq">Ebook + 3 bonos gratis</Eyebrow>
            <h1 className="font-serif tracking-tight leading-[1.02] text-[clamp(36px,6vw,64px)] mb-6 text-ink" data-id="element-16" data-mp="33es5a6zjwmca">
              Dale forma a tu historia para que por fin tenga un{' '}
              <em className="text-brand not-italic font-semibold" data-id="element-17" data-mp="2f7wsrbjosanj">camino claro</em>, de la memoria
              a la página
            </h1>
            <p className="text-lg md:text-xl text-[#405653] max-w-xl leading-relaxed mb-5" data-id="element-18" data-mp="2k4dgi4mz4n03">
              Con inteligencia artificial como apoyo y tu voz intacta: convierte recuerdos en
              personajes, estructura en actos y escenas listas para tu primer borrador.
            </p>
            <p className="text-sm font-semibold text-ink2 max-w-xl leading-relaxed mb-8 flex items-center gap-2" data-id="element-19" data-mp="1wi6yqqnqzswo">
              <Sparkles size={16} className="text-brand shrink-0" data-id="element-20" data-mp="21g079qciwz04" />
              Hoy mismo escribes tu primer párrafo — no necesitas semanas para empezar, ni
              experiencia previa escribiendo o usando IA.
            </p>

            <div className="flex items-center gap-2 mb-6 text-sm" data-id="element-21" data-mp="1dqe5cv4ro5of">
              <div className="flex text-gold" data-id="element-22" data-mp="1do1rat24qfgn">
                {Array.from({
                length: 5
              }).map((_, i) => <Star key={i} size={16} fill="currentColor" strokeWidth={0} data-id="element-23" data-mp="1imw7rocmjrxl" data-mpi={i} />)}
              </div>
              <span className="font-semibold" data-id="element-24" data-mp="3rxx6oieujpf9">4.9</span>
              <span className="text-muted" data-id="element-25" data-mp="3ryf1dalv1vl2">(500+ ventas)</span>
            </div>

            <div className="flex flex-col sm:flex-row sm:items-center gap-5 mb-6" data-id="element-26" data-mp="3mxr9yntpzcqb">
              <PrimaryButton data-id="element-27" data-mp="3i0itcro7zgr6">
                Quiero empezar hoy <span aria-hidden data-id="element-28" data-mp="3i1tusku70cf4">→</span>
              </PrimaryButton>
              <div className="flex items-center gap-2 text-sm font-semibold text-brand" data-id="element-29" data-mp="3d1fy1yy1kowe">
                <Clock size={16} data-id="element-30" data-mp="388v5t1usajuz" />
                Oferta termina en {timer}
              </div>
            </div>

            <div className="flex flex-wrap gap-x-6 gap-y-2 text-xs text-muted" data-id="element-31" data-mp="348uh8odz0sa7">
              <span data-id="element-32" data-mp="2zaasyhbwn4eo">✓ Entrega inmediata</span>
              <span data-id="element-33" data-mp="2z7evsv7vsjra">✓ Pago seguro</span>
              <span data-id="element-34" data-mp="2uaeoyi37jcz4">✓ Garantía 7 días</span>
            </div>
          </div>

          <div className="relative flex flex-col items-center gap-4 py-4" data-id="element-35" data-mp="2pbbvluwlav6z">
            <div className="absolute -z-10 w-[500px] h-[500px] rounded-full bg-brand/10 blur-3xl right-[-100px] top-10" data-id="element-36" data-mp="2pd529a77dfez" />
            <div className="bg-offwhite/95 border border-ink/10 shadow-[0_8px_20px_rgba(7,63,63,0.1)] px-5 py-3 rounded text-center" data-id="element-37" data-mp="2km9fosul0xqw">
              <b className="font-serif text-lg block" data-id="element-38" data-mp="26nt9d30mt99a">500+ personas</b>
              <small className="text-[11px] text-muted block" data-id="element-39" data-mp="2ao3i2nft6dru">ya usaron el método</small>
            </div>
            <div className="w-[260px] md:w-[320px] rounded shadow-[0_35px_75px_rgba(6,48,48,0.25)] rotate-2 overflow-hidden bg-white" data-id="element-40" data-mp="2ydfndc80m1ov">
              <img src={MAIN_IMG} alt="Escribir un libro con IA" className="w-full h-full object-cover" data-id="element-41" data-mp="33cissxrwq9xd" />
            </div>
            <div className="bg-offwhite/95 border border-ink/10 shadow-[0_8px_20px_rgba(7,63,63,0.1)] px-5 py-3 rounded text-center" data-id="element-42" data-mp="2pjjcwuo7qdpa">
              <b className="font-serif text-lg block" data-id="element-43" data-mp="3hca1qk3kh04i">+3 bonos</b>
              <small className="text-[11px] text-muted block" data-id="element-44" data-mp="3hap9j14q5t9t">que resuelven lo que sigue</small>
            </div>
          </div>
        </div>
      </section>

      {/* Pain points */}
      <section className="py-20 md:py-28 bg-offwhite" data-id="element-45" data-mp="1amq915h606kh">
        <div className="max-w-6xl mx-auto px-5" data-id="element-46" data-mp="15q86mc9b4kbb">
          <SectionHead eyebrow="¿Te identificas con esto?" title="Si alguno de estos problemas te suena familiar, este ebook es para ti" data-id="element-47" data-mp="15ndmklu7h1if" />
          <div className="grid md:grid-cols-2 gap-5" data-id="element-48" data-mp="1fgkmhr66fpb4">
            {PAIN_POINTS.map(p => <div key={p.title} className="flex gap-4 p-6 border border-ink/10 bg-paper rounded" data-id="element-49" data-mp="rqgllrkdi3nt">
                <X className="text-brand shrink-0 mt-1" size={20} data-id="element-50" data-mp="msyiiht1einq" />
                <div data-id="element-51" data-mp="11pfth7xbdv9r">
                  <h3 className="font-serif text-xl mb-1" data-id="element-52" data-mp="11liaqnenf5qe">{p.title}</h3>
                  <p className="text-muted text-[15px] leading-relaxed" data-id="element-53" data-mp="wn722g03b19r">{p.desc}</p>
                </div>
              </div>)}
          </div>
          <p className="text-center font-serif text-xl md:text-2xl text-ink mt-12" data-id="element-54" data-mp="2846ztr57i8b6">
            Si respondiste <em className="text-brand not-italic font-semibold" data-id="element-55" data-mp="hncxgwnijwqq">"sí"</em> a alguna
            de estas... tenemos la solución.
          </p>
        </div>
      </section>

      {/* Features / what's inside */}
      <section className="py-20 md:py-28" data-id="element-56" data-mp="qmzxpf4iawi7">
        <div className="max-w-6xl mx-auto px-5" data-id="element-57" data-mp="qm6rcf9gm90l">
          <SectionHead eyebrow="¿Qué vas a encontrar adentro?" title="Todo lo que necesitas en un solo lugar" data-id="element-58" data-mp="vn47kmawsszg" />
          <div className="grid sm:grid-cols-2 gap-8" data-id="element-59" data-mp="10lfh0vxal1h5">
            {FEATURES.map(f => <div key={f.title} data-id="element-60" data-mp="15j7kmn7auc16">
                <f.icon className="text-brand mb-4" size={32} strokeWidth={1.5} data-id="element-61" data-mp="1abh5hotk4lwl" />
                <h3 className="font-serif text-2xl mb-2" data-id="element-62" data-mp="1adlhku1m0r7y">{f.title}</h3>
                <p className="text-muted leading-relaxed" data-id="element-63" data-mp="1ebsq51lx6m82">{f.desc}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Bonuses */}
      <section className="py-20 md:py-28 bg-offwhite" data-id="element-64" data-mp="1oaqm2plodi13">
        <div className="max-w-6xl mx-auto px-5" data-id="element-65" data-mp="1o95qqxrjdv26">
          <SectionHead eyebrow="🎁 Bonos incluidos" title="Para que ningún bloqueo te frene en el camino" desc="Elegimos estos 3 bonos porque cada uno resuelve un problema puntual que suele aparecer después del ebook — no son regalos sueltos." data-id="element-66" data-mp="1yfgpz10n2w7y" />
          <div className="grid md:grid-cols-3 gap-6" data-id="element-67" data-mp="1kfxhu87tvkvn">
            {BONUSES.map(b => <div key={b.n} className="border border-ink/10 bg-paper p-7 rounded flex flex-col" data-id="element-68" data-mp="2h5evpagysd8f">
                <span className="text-[10px] font-bold tracking-[0.18em] text-brand mb-4" data-id="element-69" data-mp="2c751p36z7ioe">
                  BONO #{b.n}
                </span>
                <img src={b.img} alt={b.title} className="w-full h-36 object-contain mb-5 rounded bg-white" data-id="element-70" data-mp="23ejl9tqtho2q" />
                <h3 className="font-serif text-xl mb-1" data-id="element-71" data-mp="2zy0qrsk1rzry">{b.title}</h3>
                <p className="text-xs font-semibold text-ink2 mb-3" data-id="element-72" data-mp="2v3wj172yjnpt">{b.solves}</p>
                <p className="text-muted text-sm leading-relaxed mb-5 flex-1" data-id="element-73" data-mp="t8yqezh6t0ak">{b.desc}</p>
                <div className="flex items-center justify-between pt-4 border-t border-ink/10" data-id="element-74" data-mp="y7a0nbbe9ctb">
                  <span className="text-xs text-muted line-through" data-id="element-75" data-mp="jivxeza2fmc8">Valor: {b.value}</span>
                  <span className="text-xs font-bold text-brand uppercase tracking-wider" data-id="element-76" data-mp="ogp19lnwc49c">
                    Gratis
                  </span>
                </div>
              </div>)}
          </div>
          <p className="text-center mt-10 text-muted" data-id="element-77" data-mp="fhk68pbjmt1x">
            Estos bonos tienen un valor total de{' '}
            <span className="font-bold text-ink" data-id="element-78" data-mp="kjonen2geh6">{formatMXN(BONUS_TOTAL)}</span>
          </p>
        </div>
      </section>

      {/* Testimonial */}
      <section className="py-20 md:py-28" data-id="element-79" data-mp="1ux9jbyl9drpm">
        <div className="max-w-3xl mx-auto px-5" data-id="element-80" data-mp="1uycb08qeny6l">
          <SectionHead center eyebrow="Testimonios reales" title="Lo que dicen personas que ya están convirtiendo recuerdos en historias" data-id="element-81" data-mp="1uvgd2kek59i5" />
          <div className="bg-offwhite border border-ink/10 rounded-lg p-8 md:p-10 shadow-sm" data-id="element-82" data-mp="3kcbuw7znpb66">
            <div className="flex text-gold mb-4 justify-center" data-id="element-83" data-mp="3fh4t55py6gjw">
              {Array.from({
              length: 5
            }).map((_, i) => <Star key={i} size={16} fill="currentColor" strokeWidth={0} data-id="element-84" data-mp="3pdhqqeom5ejx" data-mpi={i} />)}
            </div>
            <p className="font-serif text-xl md:text-2xl text-center leading-relaxed text-ink mb-6" data-id="element-85" data-mp="6z8grq7s8hq7">
              "Yo tenía un montón de escenas de pláticas con mi abuela, pero no sabía cómo
              volverlas una historia. Con las indicaciones y el método de escenas pequeñas, por
              primera vez la trama se acomodó. La IA me ayudó, pero lo mejor fue que pude
              mantener mi forma de hablar y decidir qué quedaba y qué no."
            </p>
            <p className="text-center text-sm font-semibold text-muted" data-id="element-86" data-mp="2ir5equn48nte">— Ana López</p>
          </div>

          <div className="grid grid-cols-3 gap-6 mt-14 text-center" data-id="element-87" data-mp="2dsavxsp5ez9a">
            <div data-id="element-88" data-mp="1rw99pirmryg4">
              <p className="font-serif text-4xl text-ink" data-id="element-89" data-mp="1rupu7udstrfe">500+</p>
              <p className="text-xs uppercase tracking-wider text-muted mt-1" data-id="element-90" data-mp="1wuu24w0n5du0">Clientes</p>
            </div>
            <div data-id="element-91" data-mp="21nwuj0tomh8m">
              <p className="font-serif text-4xl text-ink" data-id="element-92" data-mp="21ndmcbtu377s">4.9</p>
              <p className="text-xs uppercase tracking-wider text-muted mt-1" data-id="element-93" data-mp="26kn9fktr36sg">Calificación</p>
            </div>
            <div data-id="element-94" data-mp="18z81lp2s5i7y">
              <p className="font-serif text-4xl text-ink" data-id="element-95" data-mp="18zr889mzck6o">100%</p>
              <p className="text-xs uppercase tracking-wider text-muted mt-1" data-id="element-96" data-mp="1dy2kss4nt8sl">Satisfacción</p>
            </div>
          </div>
        </div>
      </section>

      {/* Steps */}
      <section className="py-20 md:py-28 bg-ink text-white" data-id="element-97" data-mp="1nuxe8wm2sj00">
        <div className="max-w-6xl mx-auto px-5" data-id="element-98" data-mp="1nt48djjae2t2">
          <SectionHead light eyebrow="Cómo lo usarás (sin enredos)" title="En solo 3 pasos simples" data-id="element-99" data-mp="2uc2hzvc4ekc5" />
          <div className="border-t border-white/15" data-id="element-100" data-mp="2zcgqtfljpyb8">
            {STEPS.map(s => <div key={s.n} className="grid grid-cols-[50px_1fr] md:grid-cols-[100px_1fr] gap-6 py-8 border-b border-white/15" data-id="element-101" data-mp="nm7iongjlzn6">
                <span className="font-serif italic text-brand text-2xl md:text-3xl" data-id="element-102" data-mp="dw5wy2bnwtbf">{s.n}</span>
                <div data-id="element-103" data-mp="8x31n9lhi1gn">
                  <h3 className="font-serif text-2xl md:text-3xl mb-2" data-id="element-104" data-mp="8xl26if6j1ud">{s.title}</h3>
                  <p className="text-[#b8cfca] leading-relaxed" data-id="element-105" data-mp="3zt0iwoqg1cz">{s.desc}</p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Offer */}
      <section id="oferta" className="py-20 md:py-28 bg-gradient-to-br from-[#062f30] to-[#0b5551]" data-id="element-106" data-mp="3r4inx59dwjt2">
        <div className="max-w-5xl mx-auto px-5" data-id="element-107" data-mp="3m5xxtynujgic">
          <div className="grid md:grid-cols-[1.1fr_0.9fr] shadow-[0_25px_70px_rgba(0,0,0,0.3)] rounded-lg overflow-hidden" data-id="element-108" data-mp="1pccku3miwuqh">
            <div className="bg-ink text-white p-8 md:p-14" data-id="element-109" data-mp="1kd00pqn1e1rl">
              <Eyebrow light data-id="element-110" data-mp="1kbgkg01drqpt">Todo lo que incluye tu compra</Eyebrow>
              <h2 className="font-serif text-3xl md:text-[44px] leading-tight mb-5" data-id="element-111" data-mp="2c6t0l03gjpy0">
                Acceso inmediato a todo esto por un único pago
              </h2>
              <p className="text-[#b8cfca] mb-6" data-id="element-112" data-mp="22h16e6z9syu2">
                Ebook principal + 3 bonos, pensado para que avances sin trabarte.
              </p>
              <ul className="space-y-0" data-id="element-113" data-mp="1xgdelj37wdys">
                <li className="flex items-center justify-between py-3 border-b border-white/10" data-id="element-114" data-mp="1the13a3f78vq">
                  <span className="flex items-center gap-2" data-id="element-115" data-mp="1oh8hmh7b0soq">
                    <Check size={16} className="text-gold" data-id="element-116" data-mp="1ojupkhy3xa7h" /> Escribir un libro con IA
                  </span>
                  <span className="text-sm text-[#b8cfca]" data-id="element-117" data-mp="1jkhzlobxvn0o">{formatMXN(PRICE_ORIGINAL)}</span>
                </li>
                {BONUSES.map(b => <li key={b.n} className="flex items-center justify-between py-3 border-b border-white/10" data-id="element-118" data-mp="3dvenmsziqg14">
                    <span className="flex items-center gap-2" data-id="element-119" data-mp="3hf5cvso127oe">
                      <Check size={16} className="text-gold" data-id="element-120" data-mp="3hcj4xrx85q5n" /> Bono #{b.n}: {b.title}
                    </span>
                    <span className="text-xs font-bold text-gold uppercase" data-id="element-121" data-mp="3ldupvk55ln7i">Gratis</span>
                  </li>)}
                <li className="flex items-center justify-between py-3" data-id="element-122" data-mp="3v6jze9h58r07">
                  <span className="flex items-center gap-2" data-id="element-123" data-mp="2yfrf0zn6gcsm">
                    <Check size={16} className="text-gold" data-id="element-124" data-mp="2yhcb4tp543sl" /> Garantía de 7 días
                  </span>
                  <span className="text-xs font-bold text-gold uppercase" data-id="element-125" data-mp="32hmqgwyto6k4">Incluida</span>
                </li>
              </ul>
            </div>

            <div className="bg-paper p-8 md:p-14 flex flex-col items-center text-center" data-id="element-126" data-mp="3cf9afxuzaoay">
              <span className="text-xs uppercase tracking-wider text-muted mb-2" data-id="element-127" data-mp="mq75mr83xfbg">
                Valor total del paquete
              </span>
              <span className="block text-2xl font-serif text-muted line-through mb-5" data-id="element-128" data-mp="ro0clmh8idcs">
                {formatMXN(BUNDLE_VALUE)}
              </span>
              <div className="mb-2" data-id="element-129" data-mp="3t7h6ky8hxtns">
                <span className="text-xs uppercase tracking-wider text-brand font-bold block mb-1" data-id="element-130" data-mp="3t6fkzztutort">
                  Tu inversión hoy
                </span>
                <strong className="font-serif text-6xl leading-none text-ink" data-id="element-131" data-mp="70972ck9cgzo">
                  {formatMXN(PRICE_OFFER)}
                </strong>
                <span className="block text-xs text-muted mt-2" data-id="element-132" data-mp="3fgu919eh29ta">
                  Precio único · Acceso de por vida
                </span>
              </div>
              <PrimaryButton className="w-full mt-6" data-id="element-133" data-mp="3p5lvx34oe3xc">Comprar y comenzar mi borrador</PrimaryButton>
              <p className="text-sm font-semibold text-brand mt-4" data-id="element-134" data-mp="3kffafc5gmzjb">
                Te llevas {formatMXN(SAVINGS)} en valor extra incluido
              </p>
              <p className="text-xs text-muted mt-5 flex items-center gap-2" data-id="element-135" data-mp="2wo00oybctfy1">
                <Clock size={14} data-id="element-136" data-mp="2rpezavkd8q80" /> Quedan pocos cupos a este precio · {timer}
              </p>

              <div className="w-full border-t border-ink/10 mt-8 pt-6 flex items-start gap-3 text-left" data-id="element-137" data-mp="177eaf2qy7tht">
                <ShieldCheck className="text-brand shrink-0" size={22} data-id="element-138" data-mp="1bzxpk45aawoq" />
                <div data-id="element-139" data-mp="xarpkdymh2fs">
                  <b className="block text-sm" data-id="element-140" data-mp="xbkq2x6zmvph">Pruébalo sin riesgo: 7 días de garantía</b>
                  <small className="text-muted text-xs leading-relaxed" data-id="element-141" data-mp="12ae4qsy0gsr8">
                    Si no te gustara el ebook o sientes que no se ajusta a lo que buscabas, puedes
                    solicitar reembolso dentro de los 7 días posteriores a tu compra. El riesgo lo
                    asumimos nosotros.
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-20 md:py-28" data-id="element-142" data-mp="1l1ouh6s02zhj">
        <div className="max-w-6xl mx-auto px-5 grid md:grid-cols-[0.7fr_1.3fr] gap-16" data-id="element-143" data-mp="5i0rdxxdp3nw">
          <div data-id="element-144" data-mp="9kxfg45otrz8">
            <Eyebrow data-id="element-145" data-mp="9lgmuqxpoxz0">Preguntas frecuentes</Eyebrow>
            <h2 className="font-serif text-3xl md:text-[44px] leading-tight text-ink" data-id="element-146" data-mp="prtjze4mfwyb">
              Resolvemos todas tus dudas
            </h2>
          </div>
          <div className="border-t border-ink/10" data-id="element-147" data-mp="kzimehxcsn8x">
            {FAQS.map((f, i) => <div key={f.q} className="border-b border-ink/10" data-id="element-148" data-mp="g2s5jsdq5nmg" data-mpi={i}>
                <button onClick={() => setOpenFaq(openFaq === i ? null : i)} className="w-full flex items-center justify-between gap-6 py-6 text-left font-serif text-lg md:text-xl font-semibold" data-id="element-149" data-mp="b373h939cz5i">
                  {f.q}
                  <ChevronDown size={20} className={`shrink-0 text-brand transition-transform ${openFaq === i ? 'rotate-180' : ''}`} data-id="element-150" data-mp="13prz4lqrnxev" />
                </button>
                {openFaq === i && <p className="text-muted leading-relaxed pb-6 pr-6" data-id="element-151" data-mp="3jge676k3uyvw">{f.a}</p>}
              </div>)}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="bg-brand text-white text-center py-24 md:py-32" data-id="element-152" data-mp="1ux9xkg5irlz7">
        <div className="max-w-2xl mx-auto px-5" data-id="element-153" data-mp="1z180z31vniy2">
          <Sparkles className="mx-auto mb-6" size={28} data-id="element-154" data-mp="23z9gje03h04s" />
          <h2 className="font-serif text-3xl md:text-5xl leading-tight mb-4" data-id="element-155" data-mp="23ygf8sjwn2u1">
            Empieza hoy a darle forma a{' '}
            <em className="text-ink not-italic font-semibold" data-id="element-156" data-mp="2dpky43cpb7u5">esa historia</em> que quieres
            contar
          </h2>
          <p className="mb-2" data-id="element-157" data-mp="2io5v7twnpbed">
            <span className="line-through opacity-75 mr-3" data-id="element-158" data-mp="2in49mvi0l6ie">{formatMXN(BUNDLE_VALUE)}</span>
            <span className="font-serif text-2xl font-semibold" data-id="element-159" data-mp="2mrkfiwrmodxm">{formatMXN(PRICE_OFFER)}</span>
          </p>
          <p className="text-sm opacity-90 mb-8" data-id="element-160" data-mp="2rou1g2ft67gp">
            Ebook + 3 bonos nombrados para cada bloqueo · Garantía de 7 días
          </p>
          <a href="#oferta" className="inline-flex items-center justify-center gap-3 bg-ink text-white font-bold uppercase text-sm tracking-wider px-9 py-5 rounded shadow-lg" data-id="element-161" data-mp="xbcnn757goyv">
            Comprar y comenzar mi borrador
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#042d2d] text-[#a9c0bb] py-8 text-xs" data-id="element-162" data-mp="29ng6gpvowrbq">
        <div className="max-w-6xl mx-auto px-5 flex flex-col sm:flex-row items-center justify-between gap-3" data-id="element-163" data-mp="29kk8x2nr84nt">
          <span data-id="element-164" data-mp="2jl4c4auu3j8o">© 2026 Escribir un libro con IA. Todos los derechos reservados.</span>
          <div className="flex gap-5" data-id="element-165" data-mp="2jirll9b0g0k0">
            <a href="#" className="hover:text-white" data-id="element-166" data-mp="2emt4m6s0hktm">
              Términos y condiciones
            </a>
            <a href="#" className="hover:text-white" data-id="element-167" data-mp="2scd0qtr37jty">
              Política de privacidad
            </a>
          </div>
        </div>
      </footer>
    </div>;
}